import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { WorkoutResult } from 'types';
import { WorkoutLevelEnum } from 'types/enums';
import { client } from 'utils/api-client';

// Athlete self-serve: bulk-sets own level for a section. Hits `.../log/`, the
// self-log sibling of useSetSectionLevelAsStaff — athlete is resolved from the
// session server-side, never sent in the body.
export type SetSectionLevelInput = {
  workoutSection: string;
  level: WorkoutLevelEnum | null;
};

function useSetSectionLevel(
  workoutId: string | undefined,
): UseMutationResult<AxiosResponse<WorkoutResult[]>, AxiosError, SetSectionLevelInput> {
  const queryClient = useQueryClient();
  return useMutation(
    (input: SetSectionLevelInput) =>
      client.patch<WorkoutResult[]>('workout-results/section-level/log/', input),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['workout-athlete-results', workoutId]);
        queryClient.invalidateQueries(['workout-leaderboard', workoutId]);
      },
    },
  );
}

export default useSetSectionLevel;
